import PublishButton from "@components/Layouts/CatalogLayout/LeftNavigation/PublishButton";
import { BranchButton } from "@components/Layouts/CatalogLayout/RightNavigation/BranchButton";
import { HistoryButton } from "@components/Layouts/CatalogLayout/RightNavigation/HistoryButton";
import useIsOffline from "@ext/errorHandlers/hooks/useIsOffline";
import Sync from "@ext/git/actions/Sync/components/Sync";
import { GlassToolbar, GlassToolbarSeparator } from "@ui-kit/GlassToolbar";

interface MobileNavigationBottomProps {
	closeNavigation: () => void;
}

const MobileNavigationBottom = ({ closeNavigation }: MobileNavigationBottomProps) => {
	const isOffline = useIsOffline();

	return (
		<div className="flex justify-center p-2.5" data-qa="qa-status-bar" data-testid="mobile-navigation-bottom">
			<GlassToolbar className="relative w-fit max-w-full overflow-visible pr-1">
				<Sync disable={isOffline} />
				<BranchButton disabled={isOffline} iconOnly onToggle={closeNavigation} />
				<HistoryButton onToggle={closeNavigation} />
				<GlassToolbarSeparator />
				<PublishButton disable={isOffline} iconOnly onToggle={closeNavigation} />
			</GlassToolbar>
		</div>
	);
};

export default MobileNavigationBottom;
